// extracted by mini-css-extract-plugin
module.exports = {"primary":"#18a0fb","primaryDark":"#031a6b"};